// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"1902":"5e7ac8a5672e452bb17d","8066":"f1f0a3884f0b92377e6a"}[chunkId] + "";
};